// app/api/products/route.ts
import { NextResponse } from "next/server";
import { prisma } from "@/lib/prisma";

export async function GET() {
    const products = await prisma.product.findMany({
        include: {
            variants: true,
        },
        orderBy: {
            createdAt: "desc",
        },
    });

    return NextResponse.json(products);
}

export async function POST(req: Request) {
    const body = await req.json();

    const product = await prisma.product.create({
        data: {
            name: body.name,
            sku: body.sku,
            category: body.category,
            sourceOrigin: body.sourceOrigin,
            status: "active",
            material: body.material || null,
            description: body.description || null,
            coverImage: body.coverImage || null,
            variants: {
                create: [
                    {
                        sku: `${body.sku}-${String(body.color).toUpperCase()}-${String(body.size).toUpperCase()}`,
                        color: body.color,
                        size: body.size,
                        stock: Number(body.stock || 0),
                        reserved: Number(body.reserved || 0),
                        salePrice: body.salePrice,
                        costPrice: body.costPrice,
                    },
                ],
            },
        },
        include: {
            variants: true,
        },
    });

    return NextResponse.json(product, { status: 201 });
}